module.exports = __webpack_public_path__ + "img/UmyHead.d7b29645.png";